import round from "../../../utils/round";
import WINDOW from "../../../utils/window";

/**
 * Process custom coordinates-based parameters
 * @param {PropertyValueProps} data
 * @param {StorageItemProps} item
 */
const processCustomParameters = (data, item) => {
  const value = /** @type {Number} */ (data.get("value"));
  const unit = data.get("unit");
  const parent = item.get("parent-item");
  const name = /** @type {String} */ (item.get("name"));
  const isStart = name.startsWith("start");
  const isEnd = name.startsWith("end");

  if (parent) {
    const fn = parent.get("v_name");
    const page = fn === "page";

    if (fn === "page") {
    } else {
    }
  } else {
    const height = /** @type {Number} */ (WINDOW.get("height"));
    const width = /** @type {Number} */ (WINDOW.get("width"));
    const axisX = name.endsWith("x");
    const axisY = name.endsWith("y");

    if (unit === "%") {
      if (axisX) {
        data.set("value", round(width * (value / 100)));
      }
      if (axisY) {
        data.set("value", round(height * (value / 100)));
      }
      if (isStart) {
        data.set("value", round(height * (value / 100)));
      }
      if (isEnd) {
        data.set("value", round(height * (value / 100)));
      }
    } else {
      if (axisX) {
        if (isEnd) {
          data.set("value", round(width - value));
        }
      }
    }
  }
};

export default processCustomParameters;
